import controller from './compare.controller.js';
import service from './compare.service.js';
import template from './compare.html';
import './compare.scss';

let module = angular.module('compare', [
	'ionic'
])
.service('Compare', service)
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.compare', {
			url: '/compare?:id',
			views: {
				'tab-compare': {
					template: template,
					controller: controller,
					controllerAs: 'compare'
				}
			}
		})
})
.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/compare/compare.js